import { type HttpsCallableOptions } from 'firebase/functions';
import { Observable } from 'rxjs';
import { IDataStreamEvent } from './data-stream';

export interface IStorageResponse {
  storageUrl: string;
}

export interface IStorageResponseAPI {
  get$<T, R>(
    functionName: string,
    requestData: T,
    options?: HttpsCallableOptions
  ): Observable<IDataStreamEvent<R>>;
}
